export default "__VITE_ASSET__545646cf__"